// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFound_NotFound__k+enV","NotFound__Paragraph":"NotFound_NotFound__Paragraph__i+uGv"};